import { useEffect, useState } from 'react';
import { ToastItem, ToastPosition, ToastType } from './types';

export enum ActionType {
  OPEN_ALERT,
  CLOSE_ALERT,
  UPDATE_TOAST,
}

type Action =
  | {
      type: ActionType.OPEN_ALERT;
      toast: ToastItem;
    }
  | {
      type: ActionType.CLOSE_ALERT;
      id: string;
    }
  | {
      type: ActionType.UPDATE_TOAST;
      toast: {
        id: string;
        payload: {
          height: number;
          position: ToastPosition;
        };
      };
    };

interface State {
  toasts: ToastItem[];
}

export const TOAST_EXPIRE_DISMISS_DELAY = 1000;

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.OPEN_ALERT:
      return {
        ...state,
        toasts: [...state.toasts, action.toast],
      };

    case ActionType.CLOSE_ALERT:
      return {
        ...state,
        toasts: state.toasts.filter((item) => item.id !== action.id),
      };

    case ActionType.UPDATE_TOAST:
      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === action.toast.id ? { ...t, ...action.toast.payload } : t,
        ),
      };
  }
};

const listeners: Array<(state: State) => void> = [];

let memoryState: State = {
  toasts: [],
};

export const dispatch = (action: Action) => {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
};

export const defaultTimeouts: {
  [key in ToastType]: number;
} = {
  danger: 4000,
  success: 2000,
  dark: 1000,
  warning: 1000,
};

export const useStore = (): State => {
  const [state, setState] = useState<State>(memoryState);
  useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
  };
};

export const updateAction = (
  id: string,
  height: number,
  position: ToastPosition,
) => {
  dispatch({
    type: ActionType.UPDATE_TOAST,
    toast: { id, payload: { height, position } },
  });
};
